<template>
  <div class="typography ck-markdown-editor" :class="{ error: isError }">
    <ckeditor
      v-model="currentValue"
      :editor="editor"
      :rows="6"
      tag-name="textarea"
    ></ckeditor>
  </div>
</template>

<script>
import ClassicEditor from "@/plugins/CKEditorMDBuild.js";
export default {
  name: "MarkdownCkComponent",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    isError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editor: ClassicEditor,
    };
  },
  computed: {
    currentValue: {
      get() {
        return this.value;
      },
      set(value) {
        if (value !== this.value) {
          this.$emit("input", value);
        }
      },
    },
  },
};
</script>
<style scoped lang="less">
.ck-markdown-editor {
  & /deep/ .ck.ck-editor__editable_inline {
    min-height: 300px;
  }
  & /deep/ .ck-blurred {
    border: @input-border-width solid @input-border-color !important;
    &.error {
      border-color: red !important;
    }
  }
  & /deep/ .ck-focused {
    border: @input-border-width solid @input-focus-border-color !important;
  }

  &.error /deep/ .ck-focused {
    border-color: @error-color !important;
  }
  &.error /deep/ .ck-blurred {
    border-color: @error-color !important;
  }

  & /deep/ .ck.ck-rounded-corners {
    border-radius: @border-radius-xs;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  & /deep/ .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
  & /deep/ .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
    border-radius: @border-radius-xs;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  & /deep/ .ck.ck-button.ck-on,
  & /deep/ a.ck.ck-button.ck-on {
    color: @primary-color;
  }
  & /deep/ .ck.ck-button.ck-on,
  & /deep/ a.ck.ck-button.ck-on {
    background: @link-color;
  }

  & /deep/ .ck.ck-button:not(.ck-disabled):active,
  & /deep/ a.ck.ck-button:not(.ck-disabled):active {
    background: @link-color;
  }
  //--ck-focus-outer-shadow-geometry: 0 0 0 3px;
  &
    /deep/
    .ck.ck-list__item
    .ck-button.ck-on:focus:not(.ck-switchbutton):not(.ck-disabled) {
    background: @background-blue !important;
  }

  & /deep/ .ck.ck-button:active,
  & /deep/ .ck.ck-button:focus,
  & /deep/ a.ck.ck-button:active,
  & /deep/ a.ck.ck-button:focus {
    border-color: @primary-color;
  }

  & /deep/ .ck.ck-button:not(.ck-disabled):active,
  & /deep/ a.ck.ck-button:not(.ck-disabled):active {
    border-color: @primary-color;
    box-shadow: 0 0 0 3px @primary-color !important;
  }

  & /deep/ .ck.ck-button:active,
  & /deep/ .ck.ck-button:focus,
  & /deep/ a.ck.ck-button:active,
  & /deep/ a.ck.ck-button:focus {
    border-color: @primary-color !important;
    box-shadow: 0 0 0 3px @background-blue !important;
  }
}
</style>
